import {GET_FEEDBACK_FORM, SEND_FEEDBACK_FORM} from "@/store/modules/courses/types/action-types";
import {
    GET_FEEDBACK_FORM_LOADING,
    SEND_FEEDBACK_FORM_LOADING,
    SENT_FEEDBACK_FORM, SET_COURSE_FORMS, SET_FEEDBACK_MESSAGES
} from "@/store/modules/courses/types/mutation-types";
import {$http} from "@/utils/https";

const state = {
    sent: false,
    loading: false,
    form: null,
    formLoading: true,
    messages: null,
};

const getters = {
    sent: state => state.sent,
    loading: state => state.loading,
    form: state => state.form,
    messages: state => state.messages
};

const actions = {
    [SEND_FEEDBACK_FORM]: async ({commit}, payload) => {
        try {
            commit(SEND_FEEDBACK_FORM_LOADING, true);

            const url = process.env.VUE_APP_ROOT_COURSE;

            const response = await $http.post(`${url}course-form/save-course-feedback`, payload);
            commit(SET_FEEDBACK_MESSAGES, response.data);
        } catch (e) {
            throw e;
        } finally {
            commit(SEND_FEEDBACK_FORM_LOADING, false);
            commit(SENT_FEEDBACK_FORM, true);
        }
    },
    [GET_FEEDBACK_FORM]: async ({commit}, payload) => {
        try {
            commit(GET_FEEDBACK_FORM_LOADING, true);

            const url = process.env.VUE_APP_ROOT_COURSE;

            const response = await $http.get(`${url}course-form/show?slug=${payload.slug}&locale=${payload.locale}`);
            commit(SET_COURSE_FORMS, response.data.data);
        } catch (e) {
            throw e;
        } finally {
            commit(GET_FEEDBACK_FORM_LOADING, false);
        }
    },
};

const mutations = {
    [SEND_FEEDBACK_FORM_LOADING] (state, loading) {
        state.loading = loading
    },
    [SENT_FEEDBACK_FORM] (state, sent) {
        state.sent = sent
    },
    [SET_COURSE_FORMS] (state, form) {
        state.form = form
    },
    [GET_FEEDBACK_FORM_LOADING] (state, loading) {
        state.formLoading = loading
    },
    [SET_FEEDBACK_MESSAGES] (state, messages) {
        state.messages = messages
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};